<template>
    <div>

        <config-main-title>
            Sinônimos (Exames)
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <importacao service="procedimento_sinonimos" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                msg="Nenhuma Sinônimo identificado." 
                icon="fa-solid fa-equals" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="$util.abrirProcedimento(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span v-if="dado.procedimento">
                        {{ dado.procedimento.search }}
                    </span>
                </li>
            </div>

        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import Importacao from '../shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false, 
            options_classes: [], 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        Importacao,
    },

    computed: { 
        lista: function () { 
            let reg = this.$util.getregex(this.search);

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },
    },

    methods: { 
        load () { 
            this.$util.load(this, { 
                service:'procedimento_sinonimos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Sinônimos", path: "/config/sinonimos" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
